import ctl from '@netlify/classnames-template-literals';

export const containerStyle = ctl(`
  flex 
  items-top 
  justify-between 
  max-w-[750px] 
  my-5
`);

export const iconContainerStyle = ctl(`
  w-[110px] 
  h-[110px] 
  rounded-[50%] 
  border-[2px]
  border-anti-flash-white 
  flex 
  items-end 
  justify-center 
  overflow-hidden
`);

export const iconStyle = ctl(`
  text-[70px]
  text-anti-flash-white
`);

export const fullNameStyle = ctl(`
  text-2xl 
  font-[500] 
  text-ghost-white
`);

export const headerContentStyle = ctl(`
  flex 
  flex-col 
  justify-end 
  ml-5
`);
